import { Component, inject, Input, OnInit } from '@angular/core';
import { ManagedContentAppService } from '@app/service/managed-content-app.service';
import { ManagedContentItem } from 'src/admin/admin-portal/component/settings/components/page-content';
import { ContentMessagingCardComponent } from '../../component/content-messaging-card/content-messaging-card.component';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';

@Component({
  standalone: true,
  selector: 'dx-user-verification-error',
  templateUrl: './user-verification-error.component.html',
  imports: [ContentMessagingCardComponent, SharedUiLibraryModule]
})
export class UserVerificationErrorComponent implements OnInit {
  private readonly contentAppService = inject(ManagedContentAppService);
  @Input()
  public pageContent?: ManagedContentItem;

  public ngOnInit(): void {
    if (!this.pageContent) {
      this.contentAppService.getManagedContentForPage('Offramp').subscribe((data) => {
        this.pageContent = data || ({} as unknown as ManagedContentItem);
      });
    }
  }
}
